/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { CaseChangeEvent } from 'app/cm/lib/events';

@autoinject()
export class CaseServicesPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    private caseId!: string;

    ////****************** Element References ***************************************////

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly events: EventAggregator,
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async activate(params: { caseId: string }): Promise<void> {
        if(this.caseId !== params.caseId) {
            this.caseId = params.caseId;
        }
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////

    ////****************** Service Calls ********************************************////

}
